import { openModal } from "action/modal/openModal";
import classnames from "classnames";
import PAButton, { BUTTON_SIZE, BUTTON_TYPE } from "component/design-system/buttons/PAButton";
import PAText from "component/design-system/typography/PAText/PAText";
import { LayoutGrid, SlidersHorizontal } from "lucide-react";
import { useTranslation } from "next-i18next";
import { useState } from "react";
import { useDispatch } from "react-redux";
import HideIf from "util/HideIf";
import SortFilterButton from "./filter/sort-filter-button/SortFilterButton";
import styles from "./styles.module.scss";

function FilterActionbar(props: any) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [inSort, setInSort] = useState(false);
  const {
    filterContainerParams, appliedFilters, url, showSort = true,
  } = props;
  const { categoryAggregation } = filterContainerParams;
  const { t } = useTranslation("category");
  const dispatch = useDispatch();

  return (
    <div className={classnames(styles.buttonFilterGroup, { open: inSort })} data-testid="button-filter-group" id="filter-action-bar">
      <HideIf show={categoryAggregation && categoryAggregation.tier0s}>
        <PAButton
          className={`btn btn-action ${styles.btn} ${styles.btn_categories_select}`}
          onClick={() => dispatch(openModal("filter-sidebar", { ...filterContainerParams, isCategoryOpen: true }))}
          buttonType={BUTTON_TYPE.OUTLINE}
          size={BUTTON_SIZE.SMALL}
        >

          <LayoutGrid />
          <PAText>{` ${t("Categories")}`}</PAText>
        </PAButton>
      </HideIf>

      <PAButton
        buttonType={BUTTON_TYPE.OUTLINE}
        className={`btn btn-action ${styles.btn} ${styles.btn}`}
        onClick={() => dispatch(openModal("filter-sidebar", { ...filterContainerParams }))}
        size={BUTTON_SIZE.SMALL}
      >

        <SlidersHorizontal />
        <PAText>{` ${t("Filters")}`}</PAText>
      </PAButton>
      <HideIf show={showSort}>
        <SortFilterButton appliedFilters={appliedFilters} url={url} />
      </HideIf>

    </div>
  );
}

export default FilterActionbar;
